import client from 'helpers/client';
import cognito from 'helpers/cognito';

const authHeaders = async () => ({ headers: await cognito.getHeaderAuthorization() });

export const getPublicRevenueClaimSummary = async (daoId) => {
  const params = new URLSearchParams();
  if (daoId) params.append('daoId', daoId);
  const query = params.toString();
  const response = await client.api(
    `/revenue-claims/summary/transparency${query ? `?${query}` : ''}`,
    'get',
  );
  return response.data;
};

export const getRevenueClaimSummary = async (daoId) => {
  const params = new URLSearchParams();
  if (daoId) params.append('daoId', daoId);
  const query = params.toString();
  const response = await client.api(`/revenue-claims/summary${query ? `?${query}` : ''}`, 'get', await authHeaders());
  return response.data;
};

export const getRevenueClaims = async (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });
  const query = params.toString();
  const response = await client.api(`/revenue-claims${query ? `?${query}` : ''}`, 'get', await authHeaders());
  return response.data;
};

export const createRevenueClaim = async (body) => {
  const response = await client.api('/revenue-claims', 'post', body, await authHeaders());
  return response.data;
};
